/**
 * Media grid: on mobile, turn grid into horizontal carousel with progress bar.
 * Desktop: unchanged grid. Mobile: Flickity carousel, 248x300px cells, progress bar.
 */
(function () {
  const MOBILE_BREAK = 768;
  const instances = new Map();

  function initCarousel(container) {
    if (instances.get(container)) return instances.get(container);
    const section = container.closest('.media-grid');
    if (!section) return null;
    const progressBar = section.querySelector('.media-grid-progress-wrapper .flickity-progress--bar');
    if (typeof Flickity === 'undefined') return null;
    const flkty = new Flickity(container, {
      cellSelector: '.media-grid--item',
      wrapAround: false,
      contain: true,
      cellAlign: 'left',
      freeScroll: true,
      draggable: true,
      prevNextButtons: false,
      pageDots: false
    });

    flkty.on('scroll', function (progress) {
      if (progressBar) {
        progress = Math.max(0, Math.min(1, progress));
        progressBar.style.width = progress * 100 + '%';
      }
    });
    if (progressBar) progressBar.style.width = '0%';
    instances.set(container, flkty);
    return flkty;
  }

  function destroyCarousel(container) {
    const flkty = instances.get(container);
    if (flkty) {
      flkty.destroy();
      instances.delete(container);
    }
    const section = container.closest('.media-grid');
    if (section) {
      const progressBar = section.querySelector('.media-grid-progress-wrapper .flickity-progress--bar');
      if (progressBar) progressBar.style.width = '0%';
    }
  }

  function run() {
    if (typeof Flickity === 'undefined') {
      setTimeout(run, 100);
      return;
    }
    const isMobile = window.innerWidth <= MOBILE_BREAK;
    document.querySelectorAll('.section-media-grid .media-grid').forEach(function (section) {
      const inner = section.querySelector('.media-grid--inner');
      const hasProgress = section.querySelector('.media-grid-progress-wrapper');
      if (!inner || !hasProgress) return;
      if (isMobile) {
        initCarousel(inner);
      } else {
        destroyCarousel(inner);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('resize', function () {
    var t;
    if (t) clearTimeout(t);
    t = setTimeout(run, 100);
  });
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:section:unload', run);
  }
})();
